import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthUserRole } from './auth-user-role';

@Injectable({
  providedIn: 'root'
})
export class AuthUserService {

  constructor(private oauthService: OAuthService) {
  }

  get displayName(): String { 
    return this.identityClaims ? (this.identityClaims as any)['name'] : '-'; 
  }

  get email(): string {
    return this.identityClaims ? (this.identityClaims as any)['email'] : '-';
  }

  get roles(): Array<string> {
    return this.identityClaims ? Array.from((this.identityClaims as any)['user_roles']) : new Array();
  }

  get hasUserRole(): Boolean { return this.roles.includes(AuthUserRole.User);}
  get hasAdminRole(): Boolean { return this.roles.includes(AuthUserRole.Admin); }
  get hasHRReviewerRole(): Boolean { return this.roles.includes(AuthUserRole.HRReviewer); }
  get hasEHSReviewerRole(): Boolean { return this.roles.includes(AuthUserRole.EHSReviewer); }

  get canReadForms(): Boolean { return this.hasUserRole || this.hasAdminRole; }
  get canReadAllForms(): Boolean { return this.hasAdminRole; }
  get canReviewForms(): Boolean { return this.hasHRReviewerRole || this.hasEHSReviewerRole; }
  get canReviewHR(): Boolean { return this.hasHRReviewerRole; }
  get canReviewEHS(): Boolean { return this.hasEHSReviewerRole; }
  get canUpdateOwnForms(): Boolean { return this.hasUserRole || this.hasAdminRole; }
  get canUpdateAllForms(): Boolean { return this.hasAdminRole; }

  public get accessToken() { return this.oauthService.getAccessToken(); }
  public get refreshToken() { return this.oauthService.getRefreshToken(); }
  public get identityClaims() { return this.oauthService.getIdentityClaims(); }
  public get idToken() { return this.oauthService.getIdToken(); }
}
